import styles from "@/components/shared/app-layout/auth-loading/auth-loading.module.css";
import { Spinner } from "@/components/ui/spinner";

export const AuthLoading = () => {
    return (
        <div className={styles.auth_loading}>
            <Spinner />
        </div>
    );
};
